import React from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Divider,
} from "@mui/material";
import { Contact } from "../../types/HelpAndSupportDataTypes";

const InfoRow = ({
  label,
  value,
  underline = false,
}: {
  label: string;
  value: string;
  underline?: boolean;
}) => (
  <Box display="flex" justifyContent="space-between" alignItems="center">
    <Typography
      variant="caption"
      sx={{
        fontWeight: "500",
        textTransform: "uppercase",
        color: "#000000",
      }}
    >
      {label}
    </Typography>
    <Typography
      variant="body2"
      sx={underline ? { textDecoration: "underline" } : undefined}
    >
      {value}
    </Typography>
  </Box>
);

const ContactTable: React.FC<{ data: Contact[] }> = ({ data }) => (
  <TableContainer
    component={Paper}
    sx={{
      border: "1px solid #53686A",
      borderRadius: "6px",
      width: { xs: "100%", sm: "305px" },
      marginLeft: "0px",
      "@media (max-width: 850px)": { width: "100%" },
    }}
  >
    <Table>
      <TableBody
        sx={{
          "& .MuiTableCell-root": {
            borderBottom: "none",
            padding: { xs: "8px 16px", sm: "14px 23.46px 20px" },
          },
        }}
      >
        {data.map((contact, index) => (
          <React.Fragment key={index}>
            <TableRow>
              <TableCell>
                <InfoRow label="CALL US AT" value={contact.phone} />
              </TableCell>
            </TableRow>
            <Divider sx={{ marginX: 2, color: "#000000" }} />
            <TableRow>
              <TableCell>
                <InfoRow label="Email" value={contact.email} underline />
              </TableCell>
            </TableRow>
          </React.Fragment>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);

export default ContactTable;
